import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { environment } from '../../environments/environment';
import { EventEmitter } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-transactionalsms',
  templateUrl: './transactionalsms.component.html',
  styleUrls: ['./transactionalsms.component.css']
})
export class TransactionalsmsComponent implements OnInit {
  dataSource;
  displayedColumns = ['sno', 'service_category', 'actions'];
  p: number = 1;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  @ViewChild('fileInput') fileInput;
  private appURL: string = environment.apiUrl;
  private uploadURL: string = environment.uploadUrl;
  public myFocusTriggeringEventEmitter = new EventEmitter<boolean>();
  myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 }
    // This will disable dates starting from tomorrow
  };
  // Initialized to specific date (09.10.2018)
  model2: any = { date: { year: 2018, month: 10, day: 9 } };
  month1: any = {};
  wbetot_exp: any;
  mbetot_exp: any;
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {};
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  dataresult: any;
  content: any;
  module_access: any;
  addAccess: boolean = false;
  editAccess: boolean = false;
  viewAccess: boolean = false;
  deleteAccess: boolean = false;
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _flashMessagesService: FlashMessagesService

  ) {
  }

  openCoverages = false;
  indexSelectedCoverage = 1;

  ngOnInit(): void {

    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
      if (JSON.parse(this.currentUser['module_access'])) {
        this.module_access = JSON.parse(this.currentUser['module_access'])
      } else {
        this.module_access = ''
      }
    } else {
      this.module_access = ''
    }
    var checkAccess = this.checkModuleAcces('18');
    if (!checkAccess) {
      alert("You don't have access for this module. Please contact admin.")
      this.router.navigate(['/Selectport']);
      return;
    }

    this.model['start_date'] = '';
    this.model['end_date'] = '';
    this.model['IsActive'] = ''
    this.model['IsApproved'] = ''
    // this.displayedColumns = this.columnNames.map(x => x.id);
    this.getSMSTemplateTransactional();
  }

  onDateChanged(type, event: IMyDateModel): void {
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  getSMSTemplateTransactional() {
    this.showLoader = true;
    this.loginservice.getSMSTemplateTransactional()
      .subscribe(
        data => {
          if (data['Data'].length > 0) {
            this.loginservice.saveSMSTemplateTransactional(data, this.currentUser)
              .subscribe(
                datas => {
                  this.showLoader = false;
                  if (datas['data'].length > 0) {
                    this.dataresult = datas['data'];
                    this.content = datas['readyToSend']['0']['MessageTemplate'];
                  } else {
                    this.dataresult = [];
                  }
                }, error => { alert('Network Error saveSMSTemplateTransactional API'); });
          }
        },
        error => {
          alert('Error in getting SMS Template From SMS Gateway');
          this.search();
          this.showLoader = false;
        });
  }

  setreadyToSend(data, value) {
    this.showLoader = true;
    this.loginservice.setreadyToSend(data, value, 'sms', this.currentUser)
      .subscribe(
        datas => {
          this.showLoader = false;
          if (datas['data'].length > 0) {
            this.dataresult = datas['data'];
            this.content = datas['readyToSend']['0']['MessageTemplate'];
          } else {
            this.dataresult = [];
          }
        }, error => { alert('Network Error setreadyToSend API'); });
  }



  search() {
    // if (this.model['bill_no'] == '') {
    //   if (this.model['start_date'] == '' || this.model['end_date'] == '') {
    //     alert('Please Select Start & End Date & Bill No.');
    //     this._flashMessagesService.show('Please Select Start & End Date & Bill No.', { cssClass: 'alert-danger' });
    //     return true;
    //   }
    // } else {
    //   if (this.model['start_date'] != '' && this.model['end_date'] == '') {
    //     alert('Please Select End Date');
    //     this._flashMessagesService.show('Please Select End Date', { cssClass: 'alert-danger' });
    //     return true;
    //   } else if (this.model['start_date'] == '' && this.model['end_date'] != '') {
    //     alert('Please Select Start Date');
    //     this._flashMessagesService.show('Please Select Start Date', { cssClass: 'alert-danger' });
    //     return true;
    //   }
    // }
    this.showLoader = true;
    let data = {
      start_date: this.model['start_date'],
      end_date: this.model['end_date'],
      IsActive: this.model['IsActive'],
      IsApproved: this.model['IsApproved']
    };

    this.loginservice.getSMSTemplateTransactionalSearch(data, this.currentUser)
      .subscribe(
        datas => {
          this.showLoader = false;
          if (datas['data'].length > 0) {
            this.dataresult = datas['data'];
            this.content = datas['readyToSend']['0']['MessageTemplate'];
          } else {
            this.dataresult = [];
          }
        }, error => { alert('Network Error getSMSTemplateTransactionalSearch API'); });

  }

  reset() {
    this.model['start_date'] = '';
    this.model['end_date'] = '';
    this.model['IsActive'] = ''
    this.model['IsApproved'] = ''
    this.ngOnInit();
  }


  checkModuleAcces(module_id: string): boolean {
    if (!this.module_access) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_access)
      ? this.module_access
      : JSON.parse(this.module_access);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);
    if (mod) {
      // Set individual access flags
      this.addAccess = !!mod.add;
      this.editAccess = !!mod.edit;
      this.viewAccess = !!mod.view;
      this.deleteAccess = !!mod.delete;
      return true; // module exists
    } else {
      // If not found, reset and return false
      this.addAccess = false;
      this.editAccess = false;
      this.viewAccess = false;
      this.deleteAccess = false;
      return false;
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/transactionalsms/transactionalsms.component.ts